import { ComponentMetadataModel, ParameterMetadata, ParameterType, PrimitiveType } from '../../../api/api';

const formatOptions = ['Date', 'DateTime', 'Currency', 'Percent', 'Number', 'Link', 'PhoneLink', 'EmailLink'].map((value) => ({
	name: value,
	value,
	description: undefined,
}));

function stringParameter(name: string, displayName: string, order: number, typeCustom?: string): ParameterMetadata {
	return {
		name,
		displayName,
		order,
		type: ParameterType.Primitive,
		typeCustom,
		categories: [],
		isCollection: false,
		expectedType: { type: PrimitiveType.String },
	};
}

function formatParameter(name: string, displayName: string, order: number): ParameterMetadata {
	return {
		name,
		displayName,
		order,
		type: ParameterType.Primitive,
		categories: [],
		isCollection: false,
		expectedType: { type: PrimitiveType.String },
		valueOptions: formatOptions,
	};
}

export const ListItemMetadata: ComponentMetadataModel = {
	name: 'ListItemModel',
	displayName: 'List Item',
	category: 'Virtual',
	categories: ['Virtual'],
	description: 'The row template for items displayed by a List component.',
	parameters: [
		stringParameter('PrimaryTextField', 'Primary Text Field', 1),
		formatParameter('PrimaryTextFormat', 'Primary Text Format', 2),
		stringParameter('SecondaryTextField', 'Secondary Text Field', 3),
		formatParameter('SecondaryTextFormat', 'Secondary Text Format', 4),
		stringParameter('SupportingTextField', 'Supporting Text Field', 5),
		formatParameter('SupportingTextFormat', 'Supporting Text Format', 6),
		stringParameter('IconName', 'Icon Name', 7, 'ui:IconName'),
		stringParameter('BadgeField', 'Badge Field', 8),
		formatParameter('BadgeFormat', 'Badge Format', 9),
	],
	iconName: 'ViewList',
	isVirtual: true,
};
